export const DeleteDraftModal: string = 'DeleteDraftModal';
